import { gql, useQuery } from "@apollo/client";
import React, { useRef } from "react";
import styled from "styled-components";
import { Loading } from "../Loading";
import MagsCart from "./MagsCart";
import Arrow from "../../Assets/arrow-light.svg"
import { Link } from "react-router-dom";

const Style = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
    padding: 1rem 70px 1rem;
    width: calc(100% - 140px);
    .top {
        display: flex;
        justify-content: space-between;
        .title {
            font-size: 2rem;
            font-weight: 800;
        }
        .actions {
            cursor: pointer;
            font-size: 1.2rem;
            font-weight: 400;
            text-decoration: none;
        }
    }
    .carrousel-container {
        margin: 1rem 0 0;
        min-height: 15rem;
        overflow: hidden;
        overflow-x: auto;
        ::-webkit-scrollbar-track {
            display: none;
        }
        ::-webkit-scrollbar {
            display: none;
        }
        ::-webkit-scrollbar-thumb {
            display: none;
        }
        .carrousel-body {
            display: flex;
            gap: 1rem;
        }
    }
    .arrows {
        display: block;
        .right {
            position: absolute;
            inset: 50% 35px 0 auto;
            img {
                transform: rotate(-90deg);
            }
        }
        .left {
            position: absolute;
            inset: 50% auto 0 35px;
            img {
                transform: rotate(90deg);
            }
        }
        .design {
            width: 2rem;
            height: 2rem;
            background-color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 0.25rem;
            border: 1px solid var(--n-grey-1);
            cursor: pointer;
            box-shadow: var(--n-shadow-2);
            
            :hover {
                box-shadow: var(--n-shadow-4);
            }
        }
    }
    @media (max-width: 850px){
        width: calc(100% - 2rem);
        padding: 1rem 1rem 1rem;
        .arrows {
            display: none;
        }
    }
`;


const Mags_Query = gql`
    query MagsQuery{
        getAllMagzAdm(page: 0, paginate: 12){
            pages
            page
            paginate
            magz{
                _id
                Name
                EnName
                Group
                Number
                Image
                File
            }
        }
    }
`

// {
// 	getAllMagzAdm(page: 0, paginate: 20){
//     pages
//     page
//     paginate
//     magz{
//       _id
//       Name
//       EnName
//       Group
//       Number
//       Image
//       File
//     }
//   }
// }

export default function MagsCorrusel({data, language}) {
    const ref = useRef()
    const mags = useQuery(Mags_Query);
    const makeCarrousel = () => {
        if(mags.loading){
            return <Loading/>
        }
        if(mags.error){
            return "";
        }
        if(mags.data.getAllMagzAdm){
            let dataMag = mags.data.getAllMagzAdm.magz;
            let items = dataMag.map((v, i) => {
                return (
                   <MagsCart v={v} i={i} language={language}/>
                )
            });
            items.reverse()
            return (
                <div className="carrousel-body" style={{width: dataMag.length * ((window.innerWidth < 850) ? 60 : 22) + "%"}}>
                    {items}
                </div>
            )
        }
        return "";
    }
    const scrollFunc = (side = 1) => {
        ref.current.scrollTo({
            top: 0,
            left: ref.current.scrollLeft + (side*(window.innerWidth/2)),
            behavior: "smooth"
        })
    }
    return (
      <Style>
        <div className="top">
            <div className="title">
                {data.title}
            </div>
            <Link to={"/" + language.filename + data.link} className="actions">
                {data.more}
            </Link>
        </div>
        <div className="carrousel-container" ref={ref}>
            {makeCarrousel()}
        </div> 
        <div className="arrows">
            <div className="design right" onClick={() => scrollFunc(1)}>
                <img src={Arrow} alt="arrow"/>
            </div>
            <div className="design left" onClick={() => scrollFunc(-1)}>
                <img src={Arrow} alt="arrow"/>
            </div>
        </div>
      </Style>
  );
}
